/**
 * Generates HMAC-SHA256 token and timestamp for unauthenticated API routes.
 * Returns headers { 'x-req-token': <hex>, 'x-req-ts': <epoch seconds> }
 */

async function generateHmacHeaders(sharedSecret)
{
    const secret = sharedSecret || process.env.HMAC_SHARED_SECRET;

    if (!secret) {
        console.warn('HMAC_SHARED_SECRET is not configured');
        return {};
    }

    const ts = Math.floor(Date.now() / 1000).toString();
    const encoder = new TextEncoder();

    const key = await crypto.subtle.importKey(
        'raw',
        encoder.encode(secret),
        { name: 'HMAC', hash: 'SHA-256' },
        false,
        ['sign']
    );

    const signature = await crypto.subtle.sign('HMAC', key, encoder.encode(ts));

    const token = Array.from(new Uint8Array(signature))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');

    return {
        'x-req-token': token,
        'x-req-ts': ts
    };
}

export { generateHmacHeaders };
